// Seeded test answers must not make the first visit look like a saved profile.
export function savedProfileBiography(answers: Record<string, unknown>, insertedSamples: Record<string, unknown> = {}): string {
  const value = String(answers["pf.career.biography"] ?? "").trim();
  return value && value !== String(insertedSamples["pf.career.biography"] ?? "").trim() ? value : "";
}
